
/*eslint-disable*/
import React from "react";
// react library for routing
// reactstrap components
import {Col, Container, Modal, Nav, NavItem, NavLink, Row} from 'reactstrap';
// core components
import NotificationAlert from "react-notification-alert";
import UtilService from "../services/utilService";
import Login from "./pages/auth/Login";
import AppNavBar from "./AppNavBar";
import ReviewForm from "./pages/reviews/ReviewForm";
import auditService from "../services/auditService.js";
import AuditForm from "./pages/audit/AuditForm";

class AuditSubmission extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectKey: UtilService.uuidv4(),
            loginModal: false,
            contentData: {},
            answerId: this.props.match.params.uniqueId,
            surveyDetails: {},
            reviewFormKey: UtilService.uuidv4()
        };
        this.notify = this.notify.bind(this);
    }

    componentDidMount() {
        auditService.listQuestions().then((response) => {
            console.log(response)
            this.setState({surveyDetails: response, reviewFormKey: UtilService.uuidv4()});
        })
    }


    toggleModal = state => {
        this.setState({
            [state]: !this.state[state]
        });
    };


    notify = (type, title, message) => {
        let options = {
            place: "tc",
            message: (
                <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {title}
          </span>
                    <span data-notify="message">{message}</span>
                </div>
            ),
            type: type,
            icon: "ni ni-bell-55",
            autoDismiss: 5,
        };
        this.refs.notificationAlert.notificationAlert(options);
    };

    onChange(event) {
        this.setState({[event.target.name]: event.target.value});
    }

    render() {
        return (
            <div style={{backgroundColor: "white"}}>
                <div className="rna-wrapper">
                    <NotificationAlert ref="notificationAlert"/>
                </div>
                <AppNavBar loginModalToggle={this.toggleModal}/>

                {/* Hero Banner */}
                <div className="hero-banner" style={{height:"256px"}}>
                    <Container fluid>
                        <Row>
                            <Col>
                                <div className="hero-banner-content">
                                    <p style={{textAlign: "start"}}>Self-Assessment</p>
                                    <h1 style={{textAlign: "start"}}>Helping SMEs grow</h1>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <br/>
                <br/>
                <br/>

                <Container className="mt-10" style={{backgroundColor: "white"}}>
                    <Row>
                        <Col sm={"12"} md={"12"}>
                            <AuditForm answerId={this.props.match.params.uniqueId}
                                        surveyDetails={this.state.surveyDetails} key={this.state.reviewFormKey}/>
                        </Col>
                    </Row>
                </Container>

                <Modal
                    // size={"lg"}
                    className="modal-dialog-centered"
                    isOpen={this.state.loginModal}
                    toggle={() => this.toggleModal("loginModal")}
                >
                    <Login/>
                </Modal>

                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>

                <footer className="py-5" id="footer-main">
                    <Container>
                        <Row className="align-items-center justify-content-xl-between">
                            <Col xl="6">
                                <div className="copyright text-center text-xl-left text-muted">
                                    © {new Date().getFullYear()}{" "}
                                    <a
                                        className="font-weight-bold ml-1"
                                        href="https://sekim-international.com/"
                                        target="_blank"
                                    >
                                        Sekim International
                                    </a>
                                </div>
                            </Col>
                            <Col xl="6">
                                <Nav className="nav-footer justify-content-center justify-content-xl-end">
                                    <NavItem>
                                        <NavLink
                                            href="https://xaregrowth.com"
                                            target="_blank"
                                        >
                                            XareGrowth
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            href=""
                                            target="_blank"
                                            onClick={(event) => {
                                                this.props.history.push("/aboutUs")
                                            }}
                                        >
                                            About Us
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                            </Col>
                        </Row>
                    </Container>
                </footer>
            </div>
        );
    }
}

export default AuditSubmission;
